import { TRPCClientError } from "@trpc/client";
import type { AppRouter } from "../server/api/trpc/[trpc]";
import { parse, stringify, unflatten } from "devalue";

export function isTRPCClientError(
  cause: unknown
): cause is TRPCClientError<AppRouter> {
  return cause instanceof TRPCClientError;
}

export const transformer = {
  deserialize: (object: any) => {
    if (typeof object === "string") {
      return parse(object);
    }
    return unflatten(object);
  },
  serialize: (object: any) => {
    return stringify(object);
  },
};
